export default {"src":"/_next/static/media/AVIOS.6060f112.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};